import React, { FC , useState, useEffect} from "react";
import { NuitType } from "data/types";
import Avatar2 from "shared/Avatar2/Avatar2";
import EvenementBtns2 from "components/EvenementBtns2";
import Axios from '../../_services/caller.service';
import { useTranslation } from 'react-i18next';

export interface CardNuitProps {
  className?: string;
  author: NuitType;
  index: string;
  onBlocNotesClick: (typeEvenement: string, idEvenement: number) => void;
  onConfirmClick: (typeEvenement: string, idEvenement: number) => void;
  onInfoClick: (placeId: string, placeNom: string, latitude: string, longitude: string) => void;
  onRechercheClick?: (typeEvenement: string, idEvenement: number) => void;
  selected?: boolean;
  isMap?: boolean;
  onLocalisationClick?: (type: String) => void;
  symbole_monnaie: string;
  numDroit: number;
}

const CardNuit: FC<CardNuitProps> = ({
  className = "",
  author,
  index,
  onBlocNotesClick,
  onConfirmClick,
  onInfoClick,
  selected,
  isMap,
  onLocalisationClick,
  onRechercheClick,
  symbole_monnaie,
  numDroit
}) => {
  const { t } = useTranslation();

  const { displayName, libelle2, prix, paiement, date_paiement_hebergement, acompte_hebergement, lat, longi, lat2, longi2, avatar } = author;
  const [lienVisible, setLienVisible] = useState("");
  const [lienItineraire, setLienItineraire] = useState("");

  const [photo, setPhoto] = useState("");
  const [showOptions, setShowOptions] = useState<boolean>(false);

  useEffect(() => {
    //gestion lien lien_modifie si createur ou visiteur et etat=R pour créateur géré par l'api
    if(author.lien !== undefined && author.lien !== "" && numDroit ===1)
    {
      setLienVisible(author.lien);
    }
    else if(author.lien !== undefined && author.lien !== "" && author.etat_lien ==="V")
    {
      setLienVisible(author.lien);
    } 
    else if(author.lien !== undefined && author.lien !== "" && author.etat_lien === "M" && author.lien_modifie !== undefined && author.lien_modifie !== "")
    {
      setLienVisible(author.lien_modifie);
    }
    
    if(author.lat !== "" && author.longi !== "" && author.lat2 !== "" && author.longi2 !== "")
    {
      setLienItineraire("https://www.google.com/maps/dir/"+author.lat+","+author.longi+"/"+author.lat2+","+author.longi2+"/");
    }
    else if(author.lat !== "" && author.longi !== "")
    {
      setLienItineraire("https://www.google.com/maps/dir//"+author.lat+","+author.longi+"/");
    }
    else if(author.lat2 !== "" && author.longi2 !== "")
    {
      setLienItineraire("https://www.google.com/maps/dir//"+author.lat2+","+author.longi2+"/");
    }

  }, []);

  useEffect(() => {
   
    let imageURL: string | undefined;
 
     if(avatar !== "")
     {

       Axios.get(avatar, { responseType: 'blob' })
       .then((response) => {

         const blob = new Blob([response.data], { type: 'image/jpeg' });
         imageURL = URL.createObjectURL(blob);
         setPhoto(imageURL);
 
       })
       .catch((error) => console.error('Erreur lors du chargement de l\'image', error));
     }
     else
     {
       setPhoto("");
     }
 
     return () => {
       if (imageURL) {
         URL.revokeObjectURL(imageURL); // Révoquez l'URL seulement lorsque le composant est démonté
       }
     };
     
   }, [avatar]);

   const afficheOptions = () => {
    setShowOptions(true);
  }

  const cacheOptions = () => {
    setShowOptions(false);
  }

  return (
    <div
className={`
  ${selected ? "selectedCard" : ""}

  nc-CardNuit
  group
  relative

  flex
  flex-col
  items-center
  justify-center
  text-center

  w-full

   px-3
  ${libelle2 !== "" && displayName !== "" ? "pt-4" : "pt-3"}
pb-2

  rounded-[30px]
  overflow-visible

  bg-[linear-gradient(145deg,rgba(255,255,255,0.98)_0%,rgba(255,255,255,0.94)_55%,rgba(248,250,252,0.96)_100%)]
  dark:bg-[linear-gradient(145deg,rgba(15,23,42,0.98)_0%,rgba(17,24,39,0.96)_55%,rgba(10,15,28,0.98)_100%)]


  border
  border-white/80
 dark:border-white/10

  shadow-[0_14px_32px_rgba(15,23,42,0.10),inset_0_1px_0_rgba(255,255,255,0.95)]
  dark:shadow-[0_14px_32px_rgba(0,0,0,0.34),inset_0_1px_0_rgba(255,255,255,0.06)]

  hover:shadow-[0_18px_40px_rgba(15,23,42,0.14),inset_0_1px_0_rgba(255,255,255,0.95)]
  dark:hover:shadow-[0_18px_40px_rgba(0,0,0,0.42),inset_0_1px_0_rgba(255,255,255,0.08)]

  transition-all
  duration-300
  ease-out

  hover:-translate-y-[2px]

  ${showOptions ? "z-[300]" : "z-1"} 

  ${className}
`}
data-nc-id="CardNuit"
      onMouseOver={afficheOptions}
      onMouseLeave={cacheOptions}
    >
      {/* couche visuelle de la card, clipsée aux coins */}
<div
  className="
    pointer-events-none
    absolute
    inset-0
    rounded-[30px]
    overflow-hidden
  "
>
  {/* effet bulle 3D : lumière douce */}
  <div
    className="
      absolute
      inset-0
      rounded-[30px]
      bg-[radial-gradient(circle_at_20%_0%,rgba(255,255,255,0.95)_0%,transparent_38%),radial-gradient(circle_at_100%_100%,rgba(241,245,249,0.75)_0%,transparent_42%)]
      dark:bg-[radial-gradient(circle_at_20%_0%,rgba(255,255,255,0.08)_0%,transparent_34%),radial-gradient(circle_at_100%_100%,rgba(255,74,82,0.08)_0%,transparent_42%)]
 
    "
  />

  {/* bordure intérieure glossy */}
  <div
    className="
      absolute
      inset-[1px]
      rounded-[29px]
      border
      border-white/80
          dark:border-white/10
    "
  />

  {/* ombre interne très subtile en bas */}
  <div
    className="
      absolute
      inset-0
      rounded-[30px]
      shadow-[inset_0_-10px_22px_rgba(15,23,42,0.035)]
          dark:shadow-[inset_0_-10px_24px_rgba(0,0,0,0.24)]
    "
  />
</div>

         { (author.bloc !== "" || author.document !== "" || author.place_id !== "" || lienVisible || lienItineraire) && (
          <EvenementBtns2 onCloseOptions={cacheOptions} optionsVisibles={false} onRechercheClick={onRechercheClick} onBlocNotesClick={ author.bloc !== "" ? onBlocNotesClick : undefined} onConfirmClick={author.document !== "" ? onConfirmClick : undefined} onInfoClick={author.place_id && author.place_id !== "" && author.place_id !== "null" ? onInfoClick : undefined} placeId={author.place_id} placeNom={author.libelle2}  latitude={author.lat2} longitude={author.longi2} lienVisible={lienVisible} lienItineraire={lienItineraire} index={index || '' }/>
         )}
<div className={`relative z-10 w-full 
${libelle2 !== "" && displayName !== "" ? "mt-4" : ""}
text-center flow-root`}>

  {/* Cas 1 : image + hébergement => image flottante à droite */}
  {avatar !== "" && displayName !== "" && libelle2 !== "" && (
    <Avatar2
      imgUrl={photo}
      alt={displayName}
      className="
        float-right

        w-[80px]
        h-[64px]

        ml-2
        mb-1

        rounded-[18px]
      "
      onImageClick={cacheOptions}
    />
  )}

  {/* DISPLAY NAME */}
  {displayName !== "" && (
    <h2
      className="
      pr-4
      text-center
      
        text-xs
        font-semibold
        text-neutral-900
        dark:text-white

        leading-snug
        break-words
      "
    >
      {displayName}

      {isMap && displayName !== "" && (lat === "" || longi === "") && (
        <>
          {" "}
          <span className="inline-flex align-middle">
            <i
              className="las la-location-arrow text-rose-500"
              data-tooltip-id="myTooltip"
              data-tooltip-content={t("coordonneesGPSAbsentes")}
              data-tooltip-place="top"
              onClick={
                numDroit === 1 || numDroit === 0
                  ? () =>
                      alert(
                        "Pour placer cette ville, veuillez passer en mode modification."
                      )
                  : undefined
              }
            />
          </span>
        </>
      )}

      {isMap && displayName !== "" && lat !== "" && longi !== "" && (lat2 === "" || longi2 === "") && (
        <>
          {" "}
          <span className="inline-flex align-middle">
            <i
              className="curseurPointeur las la-location-arrow text-green-500"
              data-tooltip-id="myTooltip"
              data-tooltip-content={t("cliquezCarte")}
              data-tooltip-place="top"
              onClick={() => onLocalisationClick && onLocalisationClick("ville")}
            />
          </span>
        </>
      )}
    </h2>
  )}

  {/* LIBELLE 2 */}
  {libelle2 !== "" && (
    <h2
      className={`

        ${ displayName === "" 
          ? "text-xs font-semibold"
          : "text-xxs"
         }
        
        text-neutral-900
        dark:text-white

        leading-snug
        break-words

        ${displayName === "" ? "mt-0" : "mt-2"}
      `}
    >
      {libelle2}

      {isMap && libelle2 !== "" && (lat2 === "" || longi2 === "") && (
        <>
          {" "}
          <span className="inline-flex align-middle">
            <i
              className="las la-location-arrow text-rose-500"
              data-tooltip-id="myTooltip"
              data-tooltip-content={t("coordonneesGPSAbsentes")}
              data-tooltip-place="top"
              onClick={
                numDroit === 1 || numDroit === 0
                  ? () =>
                      alert(
                        "Pour placer cet hébergement, veuillez passer en mode modification."
                      )
                  : undefined
              }
            />
          </span>
        </>
      )}

      {isMap && libelle2 !== "" && lat2 !== "" && longi2 !== "" && (
        <>
          {" "}
          <span className="inline-flex align-middle">
            <i
              className="curseurPointeur las la-location-arrow text-green-500"
              data-tooltip-id="myTooltipLoc"
              data-tooltip-content={t("cliquezCarte")}
              data-tooltip-place="top"
              onClick={() =>
                onLocalisationClick && onLocalisationClick("hebergement")
              }
            />
          </span>
        </>
      )}
    </h2>
  )}

 {/* Cas 2 et 3 : image centrée si libelle2 est vide OU si displayName est vide */}
{avatar !== "" && (libelle2 === "" || displayName === "") && (
  <div className="mt-2 flex w-full justify-center">
    <Avatar2
      imgUrl={photo}
      alt={displayName || libelle2}
      className="
        w-[86px]
        h-[68px]

        rounded-[18px]
      "
      onImageClick={cacheOptions}
    />
  </div>
)}
</div>

      <>
    {!isMap && prix !== '' && Number(prix) !== 0 && (  <div
  className="
    w-full
    h-px

    bg-blue-100
    dark:bg-neutral-700

    mt-3
    mb-2
  "
/> )}
      {!isMap && prix !== '' && Number(prix) !== 0 ? (
        
     <div
  className="
    w-full

    flex
    items-center
    justify-between

    text-xs
    text-neutral-900
    dark:text-white
  "
>
          <span className="text-xs pt-[1px]  no-slider-margin">
          {prix} {symbole_monnaie}/{t('nuitMinuscule')}
          </span>

          <span className="text-xs pt-[1px]">
            {paiement === 'paye' && t('paye')}
            {paiement === 'paye' && <i
                        className="
                        pl-1
                          las
                          la-check
                          text-xs
                          leading-none
                          text-emerald-500
                          drop-shadow-[0_1px_1px_rgba(16,185,129,0.35)]
                        "
                      />}
            {paiement === 'sur_place' && t('surPlace')}
            {paiement === 'acompte' && (acompte_hebergement === '' || Number(acompte_hebergement) === 0) && t('acompte')}
            {paiement === 'prelev' && date_paiement_hebergement === '' && t('prelevement')}
          </span>
      </div>
      ): null}
      {!isMap && prix !== '' && Number(prix) !== 0 && (
      paiement === 'acompte' && acompte_hebergement !== '' && Number(acompte_hebergement) !== 0 && (
        <div className="py-1 px-1 mt-2 bg-blue-100 dark:bg-neutral-700 rounded-full flex items-center justify-center">
            <span className="text-xs font-medium pt-[1px]">Acompte : {acompte_hebergement} {symbole_monnaie}</span>
        </div>
      )
    )}
    {prix !== '' && Number(prix) !== 0 && (
      paiement === 'prelev' && date_paiement_hebergement !== '' && Number(date_paiement_hebergement) !== 0 && (
        <div className="py-1 px-1 mt-2 bg-blue-100 dark:bg-neutral-700 rounded-full flex items-center justify-center">
            <span className="text-xs font-medium pt-[1px]">Prélèvement : {date_paiement_hebergement}</span>
        </div>
      )
    )}
      </>
    </div>
  );
};

export default CardNuit;
